import * as React from 'react';
import type { SVGProps } from 'react';
const SvgKeyControl = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={100} height={100} fill="currentColor" viewBox="0 0 50 50" {...props}>
        <path d="M11 7c-2.75 0-5 2.25-5 5v26c0 2.75 2.25 5 5 5h28c2.75 0 5-2.25 5-5V12c0-2.75-2.25-5-5-5H11zm0 2h28c1.668 0 3 1.332 3 3v26c0 1.668-1.332 3-3 3H11c-1.668 0-3-1.332-3-3V12c0-1.668 1.332-3 3-3zm19.984 4a1 1 0 0 0-.691.293l-6 6a1 1 0 1 0 1.414 1.414L31 15.414l5.293 5.293a1 1 0 1 0 1.414-1.414l-6-6a1 1 0 0 0-.723-.293z" />
    </svg>
);
export default SvgKeyControl;
